/* eslint-disable no-unused-vars */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from 'react';
import * as Styles from '../../../../SharedModules/StyleConstant/StyleConstant';
import MaxLengthNumericEditor from '../../../../SharedModules/CustomAgGridEditor/inputComponent';
import {
  cellRenderer,
  comparatorQtr,
  cellRendererWithoutDec
} from '../../../../SharedModules/utilities/utilities';
// const currency = 'USD';

const fourDecimalRenderer = (params, a) => {
  const { value } = params;
  const { isTextColorRed } = params.colDef;
  const { printPrefixValue } = params.colDef;
  const { printPostfixValue } = params.colDef;
  if (value === '') return '';
  if (value < 0) {
    return (
      <span
        style={{
          color: isTextColorRed ? '#eb0000' : '',
        }}
      >
        {`(${printPrefixValue ? `${printPrefixValue} ` : ''}${parseFloat(value)
          .toLocaleString('en-US', {
            minimumFractionDigits: 4,
            maximumFractionDigits: 4,
          })
          .substring(1)})` + `${printPostfixValue || ''}`}
      </span>
    );
  }
  if (value > -1) {
    return (
      <span>
        {`${
          (printPrefixValue ? `${printPrefixValue} ` : '') +
          parseFloat(value).toLocaleString('en-US', {
            minimumFractionDigits: 4,
            maximumFractionDigits: 4,
          })
        }${printPostfixValue || ''}`}
      </span>
    );
  }
  return params.value || '';
};

// when we used to filter number in $ values
const textMatcherAmount = ({ filterOption, value: val, filterText }) => {
  const value = Math.abs(val).toString();
  const valueWithDollar = `$ ${value}`;
  if (filterText == null) {
    return false;
  }
  switch (filterOption) {
    case 'contains':
      return (
        value.indexOf(filterText) >= 0 ||
        valueWithDollar.indexOf(filterText) >= 0
      );
    case 'notContains':
      return (
        value.indexOf(filterText) < 0 || valueWithDollar.indexOf(filterText) < 0
      );
    case 'equals':
      return value === filterText || valueWithDollar.indexOf(filterText) === 0;
    case 'notEqual':
      return value != filterText.replace('$', '');
    case 'startsWith':
      return (
        value.indexOf(filterText) === 0 ||
        valueWithDollar.indexOf(filterText) === 0
      );
    case 'endsWith':
      const index =
        value.lastIndexOf(filterText) || valueWithDollar.indexOf(filterText);
      return index >= 0 && index === value.length - filterText.length;
    default:
      return false;
  }
};

const comparator = (a, b) => {
  return parseFloat(a) - parseFloat(b);
};

export const PreInvoiceSummary = [
  {
    headerName: 'Labeler Code',
    field: 'labelerCode',
    editable: false,
    sortable: true,
    suppressMenu: false,
    resizable: true,
    minWidth: Styles.Width_150,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',

    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Quarter',
    field: 'targetQtr',
    editable: false,
    sortable: true,
    suppressMenu: false,
    resizable: true,
    minWidth: Styles.Width_150,
    comparator: comparatorQtr,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Adjustment Units',
    field: 'adjustedUnit',
    cellRenderer: fourDecimalRenderer,
    editable: false,
    sortable: true,
    suppressMenu: false,
    resizable: true,
    minWidth: Styles.Width_150,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    alignment: 'right',
    excelAlignment: 'right',
    isTextColorRed: true,
    comparator,
  },
  {
    headerName: 'Adjusted Total Amount',
    field: 'adjustedTotalAmt',
    editable: false,
    sortable: true,
    suppressMenu: false,
    resizable: true,
    minWidth: Styles.Width_200,
    cellRenderer: cellRenderer,
    isTextColorRed: true,
    printPrefixValue: '$',
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      textMatcher: textMatcherAmount,
      refreshValuesOnOpen: true,
    },
    alignment: 'right',
    excelAlignment: 'right',
    isTextColorRed: true,
  },
  {
    headerName: 'Adjustment Record Count',
    field: 'adjustmentRecordCount',
    editable: false,
    sortable: true,
    suppressMenu: false,
    resizable: true,
    minWidth: Styles.Width_150,
    cellRenderer: cellRendererWithoutDec,
    comparator: (a, b) => parseFloat(a) - parseFloat(b),
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    alignment: 'right',
    excelAlignment: 'right',
    isTextColorRed: true,
  },
];

export const PreInvoiceDetail = [
  {
    headerName: 'Labeler Code',
    field: 'labelerCode',
    comparator: () => {},
    editable: false,
    sortable: true,
    suppressMenu: false,
    resizable: true,
    minWidth: Styles.Width_120,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Quarter',
    field: 'targetQtr',
    editable: false,
    sortable: true,
    suppressMenu: false,
    resizable: true,
    minWidth: Styles.Width_171,
    comparator: comparatorQtr,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    cellRenderer: function (params) {
      if (params.data.isBottomRow) {
        return '';
      }
      if (params.value.includes('Total')) {
        return <span style={{ fontWeight: 'bold' }}>{params.value}</span>;
      }
      return params.value;
    },
  },
  {
    headerName: 'NDC',
    field: 'ndc',
    editable: false,
    sortable: true,
    suppressMenu: false,
    resizable: true,
    minWidth: Styles.Width_150,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Adjustment Type',
    field: 'drugActivityTypeCd',
    editable: false,
    sortable: true,
    suppressMenu: false,
    resizable: true,
    minWidth: Styles.Width_200,
    cellRenderer: 'TextBoxRender',
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Adjusted Date',
    field: 'adjustedDt',
    editable: false,
    sortable: true,
    suppressMenu: false,
    resizable: true,
    minWidth: Styles.Width_150,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Adjusted Units',
    field: 'adjustedUnit',
    editable: false,
    sortable: true,
    suppressMenu: false,
    resizable: true,
    minWidth: Styles.Width_130,
    isTextColorRed: true,
    cellRenderer: fourDecimalRenderer,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    alignment: 'right',
    excelAlignment: 'right',
    comparator,
  },
  {
    headerName: 'Adjusted Total Amount',
    field: 'adjustedURA',
    editable: false,
    sortable: true,
    suppressMenu: false,
    resizable: true,
    minWidth: Styles.Width_200,
    cellRenderer: cellRenderer,
    isTextColorRed: true,
    printPrefixValue: '$',
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      textMatcher: textMatcherAmount,
      refreshValuesOnOpen: true,
    },
    alignment: 'right',
    excelAlignment: 'right',
    isTextColorRed: true,
  },
  {
    headerName: 'Adjustment Record Count',
    field: 'adjustmentRecordCount',
    editable: false,
    sortable: true,
    suppressMenu: false,
    resizable: true,
    minWidth: Styles.Width_150,
    cellRenderer: cellRendererWithoutDec,
    comparator: (a, b) => parseFloat(a) - parseFloat(b),
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    alignment: 'right',
    excelAlignment: 'right',
  },
];
